import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function KiTransparenz() {
  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-8">
            KI-Transparenz
          </h1>
          <div className="space-y-6 text-foreground-700 text-sm leading-relaxed">
            <div>
              <h2 className="font-heading text-lg text-foreground-950 mb-2">Unser Umgang mit Künstlicher Intelligenz</h2>
              <p>
                Transparenz ist uns wichtig – auch beim Einsatz von Künstlicher Intelligenz (KI).
                Auf dieser Seite möchten wir offen erläutern, an welchen Stellen unserer Website
                und unserer täglichen Arbeit KI-Technologien zum Einsatz kommen und wie wir damit umgehen.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-lg text-foreground-950 mb-2">Wo wir KI einsetzen</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <strong className="text-foreground-900">Bild- und Textunterstützung:</strong>{" "}
                  Einige Abbildungen und Formulierungen auf dieser Website werden mithilfe
                  KI-gestützter Werkzeuge erstellt oder vorgeschlagen.
                </li>
                <li>
                  <strong className="text-foreground-900">Kundenkommunikation:</strong>{" "}
                  Für allgemeine Anfragen können wir automatisierte Antwortvorschläge nutzen.
                </li>
                <li>
                  <strong className="text-foreground-900">Interne Prozesse:</strong>{" "}
                  KI unterstützt uns bei organisatorischen Aufgaben und der Bestellvorbereitung.
                </li>
              </ul>
            </div>
            <div>
              <h2 className="font-heading text-lg text-foreground-950 mb-2">Menschliche Kontrolle</h2>
              <p>
                Sämtliche KI-gestützten Inhalte werden von unserem Team geprüft und freigegeben.
                Für die Qualität unserer Floristik, Beratung und persönlichen Betreuung stehen
                weiterhin ausnahmslos unsere Menschen. KI ersetzt niemals die persönliche
                Beratung vor Ort – sie unterstützt uns lediglich im Hintergrund.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-lg text-foreground-950 mb-2">Ihre Rechte</h2>
              <p>
                Sie haben jederzeit die Möglichkeit, Ihre Anliegen persönlich mit uns zu besprechen.
                Auf Wunsch vermitteln wir Ihnen gerne einen direkten Ansprechpartner und verzichten
                für Ihr Anliegen vollständig auf automatisierte Verarbeitung.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-lg text-foreground-950 mb-2">Fragen zur KI-Transparenz?</h2>
              <p>
                Ihr primärer Ansprechpartner für alle Fragen rund um den Einsatz von Künstlicher
                Intelligenz ist die <strong className="text-foreground-900">Coonex-Digital GmbH</strong>,
                erreichbar per E-Mail an{" "}
                <a href="mailto:kontakt@coonex-digital.de" className="text-primary-600 hover:text-primary-700 underline">
                  kontakt@coonex-digital.de
                </a>
                . Zusätzlich erreichen Sie uns telefonisch unter 0491 928 542-30.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}